export const DrawingPage: React.FC = () => (
  <section id="drawing" className="page-section">
    <div className="page-header">
      <div>
        <p className="page-eyebrow">Giveaways</p>
        <h2 className="page-title">Drawing</h2>
        <p className="page-copy">Winner selection workspace inspired by the live dual-pool drawing flow.</p>
      </div>
    </div>
    <div className="drawing-grid">
      <article className="pool-card">
        <div className="pool-header pool-header-member">
          <p className="pool-header-title">Member Pool</p>
          <span className="pool-count">Ready</span>
        </div>
        <div className="pool-body">
          <p>Use this panel for eligible member entries, live winner reveals, and redraw controls.</p>
          <button type="button" className="primary-action" disabled>
            Draw Winner
          </button>
        </div>
      </article>
      <article className="pool-card">
        <div className="pool-header pool-header-guest">
          <p className="pool-header-title">Guest Pool</p>
          <span className="pool-count">Ready</span>
        </div>
        <div className="pool-body">
          <p>Mirror the guest drawing behavior here with separate eligibility logic and presentation.</p>
          <button type="button" className="secondary-action" disabled>
            Draw Guest Winner
          </button>
        </div>
      </article>
    </div>
  </section>
);
